module.exports = __webpack_public_path__ + "static/img/prompt.f1fde707.png";